import { CssBaseline } from "@mui/material";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { DialogProvider } from "components/AwaitableDialog/DialogProvider";
import ErrorBoundary from "components/ErrorBoundary";
import SettingsProvider from "context/SettingsProvider";
import SnackbarProvider from "context/snackbar";
import Router from "pages";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as StoreProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import ServiceWorkerWrapper from "serviceWorkerWrapper";
import { store } from "store";
import "style.css";
import theme from "theme";
import { Userpilot } from "userpilot";

Userpilot.initialize("NX-0f4a7803");

if (navigator.storage?.persist) {
  navigator.storage.persist().then((granted) => {
    console.log("persisting", granted);
  });
}

const root = createRoot(document.getElementById("root") as Element);
root.render(
  <StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <StoreProvider store={store}>
          <ErrorBoundary>
            <SettingsProvider>
              <SnackbarProvider>
                <DialogProvider>
                  <CssBaseline />
                  <BrowserRouter>
                    <Router />
                    <ServiceWorkerWrapper />
                  </BrowserRouter>
                </DialogProvider>
              </SnackbarProvider>
            </SettingsProvider>
          </ErrorBoundary>
        </StoreProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// We are calling serviceWorker.register from <ServiceWorkerWrapper /> component
//serviceWorkerRegistration.register();
